import { FunctionComponent } from 'react'
import useWindowWidth from '../../../../shared/hooks/useWindowWidth'
import Alert, { AlertLevel } from '../../../../shared/components/Alerts/Alert'

const ExplosivesMapBanner: FunctionComponent<{ legacyMap?: boolean }> = ({ legacyMap }) => (
  <Alert level={AlertLevel.Warning} data-testid="explosivesBanner" mapBanner legacyMap={legacyMap}>
    <p>
      Let op: De kaart van de gemeente Amstelveen{' '}
      <a href="https://aa.kaartviewer.nl/?@Explosieven" target="_blank" rel="noreferrer">
        kunt u hier vinden
      </a>
    </p>
  </Alert>
)

const OpenbaarMeldingBanner: FunctionComponent<{ legacyMap?: boolean }> = ({ legacyMap }) => (
  <Alert level={AlertLevel.Warning} data-testid="meldingBanner" mapBanner legacyMap={legacyMap}>
    <p>
      Meer{' '}
      <a href="https://meldingen.amsterdam.nl/meldingenkaart" target="_blank" rel="noreferrer">
        details
      </a>{' '}
      over meldingen in de openbare ruimte waarmee we aan het werk zijn.
    </p>
  </Alert>
)

const TreesMapBanner: FunctionComponent<{ legacyMap?: boolean }> = ({ legacyMap }) => (
  <Alert level={AlertLevel.Warning} data-testid="treesBanner" mapBanner legacyMap={legacyMap}>
    <p>
      Tot en met 2025 actualiseren we de kaart. De beschikbare online data zijn steeds een
      momentopname. Aan de kaart kunnen geen rechten worden ontleend. Meer informatie is{' '}
      <a
        href="https://www.amsterdam.nl/bestuur-organisatie/volg-beleid/groen/bomen/?vkurl=bomen"
        target="_blank"
        rel="noreferrer"
      >
        hier
      </a>{' '}
      te vinden. Daarnaast is er een{' '}
      <a href="https://bomen.amsterdam.nl" target="_blank" rel="noreferrer">
        bomenkaart
      </a>{' '}
      beschikbaar voor specifieke informatie over de bomen.
    </p>
  </Alert>
)

/**
 * show a notification for the explosives map layer or the trees map layer
 */
function explosivesMapLayerVisible(layers?: string[]) {
  const explosivesLayer = layers?.find(
    (layer: string) => layer.startsWith('explsvn-') || layer.startsWith('ondrgd-ex'),
  )
  return !!explosivesLayer
}

function openbaarMeldingLayerVisible(layers?: string[]) {
  const omLayer = layers?.find((layer: string) => layer.startsWith('mobr-'))
  return !!omLayer
}

function treesMapLayerVisible(layers?: string[]) {
  const treeLayer = layers?.find((layer: string) => layer.startsWith('oor-'))
  return !!treeLayer
}

const MapBanner: FunctionComponent<{ legacyMap?: boolean }> = ({ legacyMap }) => {
  const width = useWindowWidth()
  const showBanner = legacyMap ? width > 1360 : true

  if (showBanner) {
    const params = new URLSearchParams(window.location.search)
    const layers = params.get('lagen')?.split('|')

    if (explosivesMapLayerVisible(layers)) {
      return <ExplosivesMapBanner legacyMap={legacyMap} />
    }

    if (openbaarMeldingLayerVisible(layers)) {
      return <OpenbaarMeldingBanner legacyMap={legacyMap} />
    }

    if (treesMapLayerVisible(layers)) {
      return <TreesMapBanner legacyMap={legacyMap} />
    }
  }

  return null
}

export default MapBanner
